import { mentionDocExtension, mentionTranscriptionExtension, mentionTableRowExtension, imageExtension } from './chunk-HNGBS43S.js';
import { BaseEditorExtension, mentionExtension } from './chunk-KQ45IS4N.js';
import { getSchema } from '@tiptap/core';

var basicEditorExtensions = [
  BaseEditorExtension.configure(),
  mentionExtension.configure(),
  mentionDocExtension.configure(),
  mentionTranscriptionExtension.configure(),
  mentionTableRowExtension.configure(),
  imageExtension.configure()
];
var basicEditorSchema = getSchema(basicEditorExtensions);

export { basicEditorSchema };
